
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.95 2.55l3.5 3.5-7.6 7.602-3.122.344a.656.656 0 01-.724-.725l.347-3.123L7.95 2.549zm5.666-.522L11.972.385a1.313 1.313 0 00-1.857 0L8.569 1.93l3.5 3.5 1.546-1.546a1.313 1.313 0 000-1.857z","fill":"#000"}})])
          )
        }
      }
    